var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-search-screen l-container"},[(_vm.productsData && _vm.productsData.length)?_c('search-panel',{attrs:{"popular-searches":_vm.popularSearches,"trending-products":_vm.productsData}}):_c('div',{staticClass:"c-search-screen__loader"},[_c('loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }